var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RadarChart',{attrs:{"chart-data":_vm.data_collection,"options":_vm.data_options,"height":null,"width":null}})}
var staticRenderFns = []

export { render, staticRenderFns }